/**
 * page-howto-side.ts
 * スクロールに応じてサイドナビゲーションの現在位置をハイライトする
 *
 * @description
 * `.cnt__innerCnt`がビューポート内に入ったとき、
 * 対応する`.cnt__wrapperSideRow`に`.is-crnt`クラスを付与する
 */

const sections = document.querySelectorAll<HTMLElement>('.cnt__innerCnt');
const sideRows = document.querySelectorAll<HTMLElement>('.cnt__wrapperSideRow');

if (sections.length > 0 && sideRows.length > 0) {
  /**
   * 指定されたセクションIDに対応するサイドナビ項目をアクティブにする
   * @param {string} sectionId - アクティブにするセクションのID
   */
  const setActiveRow = (sectionId: string): void => {
    sideRows.forEach((row) => {
      const rowId = row.getAttribute('id');
      if (rowId === sectionId) {
        row.classList.add('is-crnt');
      } else {
        row.classList.remove('is-crnt');
      }
    });
  };

  const observerOptions: IntersectionObserverInit = {
    root: null,
    // ビューポートの中央付近で判定するために調整
    rootMargin: '-40% 0px -40% 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const sectionId = entry.target.getAttribute('id');
        if (sectionId) {
          setActiveRow(sectionId);
        }
      }
    });
  }, observerOptions);

  sections.forEach((section) => {
    observer.observe(section);
  });
}
